document.addEventListener('click', (event) => {
  const link = event.target.closest('header-drawer a[href]');
  if (!link) return;
  const destination = new URL(link.href, location.href);
  if (destination.origin !== location.origin || destination.pathname !== location.pathname || !destination.hash) return;
  const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
  const drawer = link.closest('header-drawer');
  const summary = drawer.querySelector('summary');
  if (!target || typeof drawer.closeMenuDrawer !== 'function') return;
  event.preventDefault();
  drawer.closeMenuDrawer(event, summary);
  summary.setAttribute('aria-expanded', 'false');
  history.replaceState(null, '', destination.pathname + destination.search + destination.hash);
  requestAnimationFrame(() => target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' }));
});
